import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getSampleExam = (params) => {
	const url = ApiRouters.GET_SAMPLE_EXAM;
	return api.get(url, { params });
};
export const getSampleExamById = (id, params) => {
	const url = `${ApiRouters.GET_SAMPLE_EXAM_BY_ID}/${id}`;
	return api.get(url, { params });
};
export const deleteSampleExam = (id) => {
	const url = `${ApiRouters.DELETE_SAMPLE_EXAM}/${id}`;
	return api.delete(url, { id });
};

export const postSampleExam = (model) => {
	const url = `${ApiRouters.POST_SAMPLE_EXAM}`;
	return api.post(url, model);
};
export const putSampleExam = (model) => {
	const { id } = model;
	const url = `${ApiRouters.PUT_SAMPLE_EXAM}/${id}`;
	return api.put(url, model);
};

export const getQuestionForCreate = (params) => {
	const url = `${ApiRouters.GET_QUESTION_FOR_CREATE}`;
	return api.get(url, { params });
};

export const getSpecialStundentsMockTest = (params) => {
	const url = `${ApiRouters.SPECIAL_STUDENTS_MOCKTEST}`;
	return api.get(url, { params });
};

export const addSpecialStundentsMockTest = (model) => {
	const url = `${ApiRouters.SPECIAL_STUDENTS_MOCKTEST}`;
	return api.post(url, model);
};

export const getSpecialStundentsMockTestById = (id, params) => {
	const url = `${ApiRouters.SPECIAL_STUDENTS_MOCKTEST}/${id}`;
	return api.get(url, { params });
};

export const putSpecialStundentsMockTest = (model) => {
	const { id } = model;
	const url = `${ApiRouters.SPECIAL_STUDENTS_MOCKTEST}/${id}`;
	return api.put(url, model);
};

export const deleteSpecialStundentsMockTest = (id) => {
	const url = `${ApiRouters.SPECIAL_STUDENTS_MOCKTEST}/${id}`;
	return api.delete(url, { id });
};
